module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAtBAMAAABL8MaSAAAAHlBMVEVHcEySkpKRkZGSkpKTk5OPj4+QkJCSkpKRkZGSkpJrDiajAAAACXRSTlMAYFj1UBB6ziZA8h6PAAAAcklEQVQoz2NgrJyJANMVGCRnIoNJDJVFLgigPp1hpgADAjDOZJipMMofUnzRUAQIBPJRASa/LA0B0oF8ByTzmGDmMxoLoNjXOXMGCt9z5hQUfvBMUxQ+R1oDjI+WvioLBRFAfDqDJorzpjCwFBsjgLkDAO3mdDmL3s9SAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile.png
// module id = HXsc
// module chunks = 0